
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stake",
      function () {
        return require("private-next-pages/stake.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stake"])
      });
    }
  